import { Space, TableColumnsType, Tag } from "antd";

export interface RecordRow {
  name: string;
  color: string;
  type: string;
  onClick: () => void;
}

export const BASE_REQUIREMENTS_TABLE_HEAD: TableColumnsType<RecordRow> = [
  {
    title: "Nombre",
    dataIndex: "name",
    key: "name",
    render: (_: any, record: RecordRow) => <Space>{record.name}</Space>,
    defaultSortOrder: "ascend",
    sorter: (a, b) => a.name.localeCompare(b.name),
    sortDirections: ["ascend", "descend"],
  },
  {
    title: "Tipo",
    dataIndex: "type",
    key: "type",
    render: (_: any, record: RecordRow) => (
      <Space>
        <Tag color={record.color}>{record.type}</Tag>
      </Space>
    ),
    defaultSortOrder: "ascend",
    sorter: (a, b) => a.type.localeCompare(b.type),
    sortDirections: ["ascend", "descend"],
  },
  /*{
    title: <span className="mx-auto flex justify-center">Acciones</span>,
    key: 'detail',
    render: (_: any, record: RecordRow) => (
      <Space className="flex justify-center items-center w-full">
        <Tooltip content="Ver detalles">
          <IconButton variant="text" onClick={record.onClick}>
            <EyeIcon className="h-4 w-4"/>
          </IconButton>
        </Tooltip>
      </Space>
    ),
  },*/
];
